import { useContext } from 'react';
import { ArtifactDrawerContext } from '../contexts/ArtifactDrawerContext';
/**
 * Hook for accessing artifact drawer context
 * Must be used within ArtifactDrawerProvider
 * @returns The artifact drawer context
 * @throws Error if used outside of ArtifactDrawerProvider
 */ export function useArtifactDrawer() {
    const context = useContext(ArtifactDrawerContext);
    if (!context) {
        throw new Error('useArtifactDrawer must be used within ArtifactDrawerProvider');
    }
    return context;
}
